const ExternalLink = {
  ManualCashInForm:
    "https://forms.office.com/Pages/ResponsePage.aspx?id=vnx1FwB3fkCy3NNfSZOMNswtLw4mzLdBjXEmh-dcR8xUQzM2T0NRSDcxRzRVSUczS01VQVZKSEVRRi4u",
};

export default ExternalLink;
